<div class="d-flex sub-section-sub-label mb-12">
  <span>{{
    T.settings.employees_departments_org.manage_employee.localisedEmployee_can_see
      | translate: { localisedEmployee: localisedEmployee }
  }}</span>
</div>
<div class="projects-tasks-read-permissions">
  <div class="department-radio-buttons row">
    <app-radio-button
      id="canSeeAll"
      class="mb-2 mb-md-0 col-12 col-md-4"
      [checked]="
        readNonConfidentialDepVisibility === departmentVisibilites.All_Departments || isInPrimaryRole
      "
      [disabled]="
        isInPrimaryRole ||
        isInRole(managerRole) ||
        writeNonConfidentialDepVisibility === departmentVisibilites.All_Departments
      "
      [text]="T.common.all_items | translate: { items: localisedDepartments }"
      (checkedChanged)="
        changeDepartmentVisibility(departmentVisibilites.All_Departments, readWriteTypes.read)
      "
    >
    </app-radio-button>
    <app-radio-button
      id="canSeeTheirDepartment"
      class="mb-2 mb-md-0 col-12 col-md-5"
      *ngIf="isDepartmentSelected"
      [disabled]="
        isInPrimaryRole ||
        isInRole(managerRole) ||
        writeNonConfidentialDepVisibility === departmentVisibilites.All_Departments
      "
      [checked]="readNonConfidentialDepVisibility === departmentVisibilites.Only_User_Department"
      [text]="T.common.only_their_localisedDepartment | translate: { localisedDepartment: localisedDepartment }"
      (checkedChanged)="
        changeDepartmentVisibility(
          departmentVisibilites.Only_User_Department,
          readWriteTypes.read
        )
      "
    >
    </app-radio-button>
    <app-radio-button
      id="cantSee"
      class="mb-2 mb-md-0 col-12 col-md-3"
      [checked]="readNonConfidentialDepVisibility === departmentVisibilites.Nothing"
      [text]="T.settings.employees_departments_org.manage_employee.just_owned_items | translate"
      [disabled]="
        isInPrimaryRole ||
        isInRole(managerRole) ||
        writeNonConfidentialDepVisibility === departmentVisibilites.All_Departments ||
        writeNonConfidentialDepVisibility === departmentVisibilites.Only_User_Department
      "
      (checkedChanged)="
        changeDepartmentVisibility(departmentVisibilites.Nothing, readWriteTypes.read)
      "
    >
    </app-radio-button>
  </div>
</div>
<div class="d-flex sub-section-sub-label mt-24">
  <span>{{
    T.settings.employees_departments_org.manage_employee.localisedEmployee_can_edit
      | translate: { localisedEmployee: localisedEmployee }
  }}</span>
</div>
<div class="projects-tasks-write-permissions mt-8">
  <div class="department-radio-buttons row">
    <app-radio-button
      id="canEditAll"
      class="mb-2 mb-md-0 col-12 col-md-4"
      [checked]="
        writeNonConfidentialDepVisibility === departmentVisibilites.All_Departments || isInPrimaryRole
      "
      [disabled]="isInPrimaryRole || isInRole(managerRole)"
      [text]="T.common.all_items | translate: { items: localisedDepartments }"
      (checkedChanged)="
        changeDepartmentVisibility(departmentVisibilites.All_Departments, readWriteTypes.write)
      "
    >
    </app-radio-button>
    <app-radio-button
      id="canEditTheirDepartment"
      [disabled]="isInPrimaryRole || isInRole(managerRole)"
      *ngIf="isDepartmentSelected"
      class="mb-2 mb-md-0 col-12 col-md-5"
      [checked]="writeNonConfidentialDepVisibility === departmentVisibilites.Only_User_Department"
      [text]="T.common.only_their_localisedDepartment | translate: { localisedDepartment: localisedDepartment }"
      (checkedChanged)="
        changeDepartmentVisibility(
          departmentVisibilites.Only_User_Department,
          readWriteTypes.write
        )
      "
    ></app-radio-button>
    <app-radio-button
      id="cantEdit"
      class="mb-2 mb-md-0 col-12 col-md-3"
      [disabled]="isInPrimaryRole || isInRole(managerRole)"
      [checked]="writeNonConfidentialDepVisibility === departmentVisibilites.Nothing"
      [text]="T.settings.employees_departments_org.manage_employee.just_owned_items | translate"
      (checkedChanged)="
        changeDepartmentVisibility(departmentVisibilites.Nothing, readWriteTypes.write)
      "
    ></app-radio-button>
  </div>
</div>
